import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import GenericViewPanel from './../GenericViewPanel';
import DocumentList from '..//DocumenList';

import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';

import { Grid } from '@material-ui/core';

import DocumentSearchDialog from '../DocumentSearchDialog';

import {
  IconButton,
  Typography,
  LinearProgress,
  DialogTitle,
  Button
} from '@material-ui/core';

import { useState, useEffect } from 'react';

const useStyles = makeStyles((theme) => ({
  actionBar: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2)
  },
  title: {
    marginBottom: theme.spacing(2)
  }
}));

const DocumentLibraryPanel = (props) => {
  const classes = useStyles();
  const {
    documents,
    allDocumentsForLibrary,
    currentDirectory,
    defaultDirectory,
    onShowFolderItems,
    onBackClicked,
    onReset,
    handleDocumentSelected,
    fetchAllDocumentsForLibrary,
    isLoading,
    branchId
  } = props;

  React.useEffect(
    () => {
      fetchAllDocumentsForLibrary(branchId);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const [open, setOpen] = useState(false);

  const handleFolderClick = (folder) => {
    onShowFolderItems(folder.documentName);
  };

  const handleDocumentClick = (document) => {
    window.open(document.blobFullUrl, '_blank', 'noopener,noreferrer');
    // handleDocumentSelected(documentLink);
  };

  const handleBackButtonClicked = () => {
    onBackClicked();
  };

  const handleRemoveButtonClicked = () => {
    // handleDocumentSelected(null);
  };

  const handleSearchClosed = () => {
    setOpen(false);
  };

  const showBackBtn = currentDirectory === defaultDirectory ? false : true;

  return (
    <GenericViewPanel>
      {open && (
        <DocumentSearchDialog
          open={open}
          documents={allDocumentsForLibrary}
          handleSearchClosed={handleSearchClosed}
          handleDocumentClick={handleDocumentClick}
        />
      )}

      <div className={classes.actionBar}>
        <Grid container spacing={3}>
          <Grid xs={10} item>
            <DialogTitle
              id="alert-dialog-title"
              className={classes.dialogTitle}
            >
              Library
            </DialogTitle>
          </Grid>
          <Grid xs={2} item>
            {documents && documents.length > 0 && (
              <Button
                color="primary"
                variant="contained"
                onClick={() => setOpen(true)}
              >
                Search Documents
              </Button>
            )}
          </Grid>
        </Grid>

        {isLoading ? <LinearProgress /> : ''}
        {!isLoading && (
          <Fragment>
            {showBackBtn ? (
              <div className={classes.backArrowContainer}>
                <IconButton
                  color="inherit"
                  onClick={handleBackButtonClicked}
                  id="settings-button"
                  className={classes.backArrow}
                >
                  <ArrowBackIcon color="primary" />
                </IconButton>
                <Typography className={classes.simpleLabel}>
                  {' '}
                  {currentDirectory}
                </Typography>
              </div>
            ) : (
              <div className={classes.backArrowContainer}>
                <Typography className={classes.simpleLabel}>
                  {' '}
                  {currentDirectory}
                </Typography>
              </div>
            )}
            {documents && (
              <DocumentList
                documents={documents}
                handleFolderClick={handleFolderClick}
                handleDocumentClick={handleDocumentClick}
              />
            )}
          </Fragment>
        )}
      </div>
    </GenericViewPanel>
  );
};

export default DocumentLibraryPanel;
